<template>
    <div class="container-izracun">
        <form class="vue-form" @submit.prevent="checkValidation">
            <h2 class="naslov-za-izracun">
                KAKO ELEKTRIČNI RENAULT ČUVA OKOLIŠ?
            </h2>
            <p class="podnaslov">
                ALAT ZA IZRAČUN ENERGETSKIH I OKOLIŠNIH ZNAČAJKI EKSPLOATACIJE BATERIJSKIH ELEKTRIČNIH LAKIH
                GOSPODARSKIH VOZILA
            </p>
            <p class="tekst">
                Ramišljate o kupnji lakog gospodarskog vozila te Vam je bitan utjecaj na okoliš?
                Pođite s nama
                na ovo zanimljivo putovanje i saznajte brojne prednosti zbog kojih ćete se još više zaljubiti
                u naše nove električne Renault modele u kategoriji lakih gospodarskih vozila.
            </p>

            <div class="buttonWrap">
                <button class="accordion border-1" type="button" @click="
            (ev) => {
              ev.currentTarget.classList.toggle('active');
            }
          ">
                    O čemu se tu zapravo radi?
                </button>
                <div class="panel">
                    <p>
                        Alat za izračun energetskih i okolišnih značajki eksploatacije baterijskih električnih lakih
                        gospodarskih vozila (eng. Battery Electric Light Commercial Vehicle – BELCV) daje uvid u
                        korištenje BELCV u kontekstu aktualnih klimatskih promjena. U alat je uključeno iskustvo tvrtke
                        Adria P.A. stečeno dugogodišnjim odnosima s poslovnim klijentima, odnosno referentne vrijednosti
                        potrebne za rad alata i baza s podacima o vozilima. Rješenje je komplementarno alatu za koji se
                        odnosi na BEV u kategoriji osobnih vozila te kao takvo predstavlja stručnu podršku u kupnji i
                        donošenju informiranih odluka u segmentu poslovnih kupaca.
                    </p>
                    <p>
                        Svrha predmetnog projekta je formalizirati znanje i iskustvo koje postoji u akademskoj zajednici
                        u oblik koji će omogućiti osmišljavanje i uspostavu inovativnog rješenja. Definiranjem
                        referentnih podataka za izračun i skupa informacija za bazu podataka vozila, odnosno
                        osmišljavanjem matematičkog modela kao osnove alata, korisnicima će se pružiti uvid u energetske
                        uštede i posljedično okolišne učinke tijekom faze eksploatacije BELCV, odnosno predstavljat će
                        podlogu za razvoj slijednih aplikacija vezanih za područje elektromobilnosti, a u sam alat će
                        biti ugrađeno iskustvo tvrtke Adria P.A. Obzirom da je sve veći udio poslovnih subjekata koji se
                        koristi suvremenim tehnologijama prilikom procesa odlučivanja, a što je posebno slučaj za
                        značajnije izdatke kao što je nabavka flote vozila, korištenje alata koji doprinosi informiranoj
                        kupnji će u razdoblju koje slijedi imati sve veći značaj prilikom odluke o nabavci vozila.
                    </p>
                </div>
            </div>
            <fieldset>
                <div>
                    <label class="label" for="vrsta_punionice">
                        Koju vrstu punionice planirate koristiti?
                    </label>
                    <select class="form-control" v-model="vrsta_punionice" id="vrsta_punionice" required>
                        <option value="javne">Samo javne punionice</option>
                        <option value="privatne">Samo privatne punionice (kod kuće, na poslu, itd.)
                        </option>
                        <option value="oboje">Kombinirano javne i privatne
                        </option>
                    </select>
                </div>
                <div v-if="vrsta_punionice === 'oboje'">
                    <label class="label tooltip" for="omjer">
                        Ako ćete koristiti kombinirano javne i privatne punionice, u kojem ćete ih omjeru
                        koristiti?
                    </label>
                    <select class="form-control" v-model="omjer" id="omjer">
                        <option value="0.8">80% javne, 20% privatne</option>
                        <option value="0.65">65% javne, 35% privatne</option>
                        <option value="0.5">50% javne, 50% privatne</option>
                        <option value="0.35">35% javne, 65% privatne</option>
                        <option value="0.2">20% javne, 80% privatne</option>
                    </select>
                </div>
                <div v-if="vrsta_punionice === 'oboje' || vrsta_punionice === 'privatne'">
                    <label class="label tooltip" for="em_faktor">
                        Ako ćete koristiti privatne punionice (same ili u kombinaciji s javnim), koji će biti udio
                        obnovljivih izvora energije na privatnim punionicama?
                        <div class="tooltiptext">
                            Zašto je to bitno? Što je „zelenija“ energija kojom punite električni Renault, to je manja
                            emisija stakleničkih plinova.
                        </div>
                    </label>
                    <select class="form-control" v-model.number="emisijski_faktor" id="em_faktor" required>
                        <option value="0">0% energije iz lokalnih obnovljivih izvora</option>
                        <option value="0.25">25% energije iz lokalnih obnovljivih izvora
                        </option>
                        <option value="0.5">50% energije iz lokalnih obnovljivih izvora
                        </option>
                        <option value="0.75">75% energija iz lokalnih obnovljivih izvora energije
                        </option>
                        <option value="1">100 % energija iz lokalnih obnovljivih izvora energije</option>
                    </select>
                </div>
                <div>
                    <label class="label tooltip" for="godisnja_km">
                        Koliko prosječno kilometara godišnje vozite?
                        <div class="tooltiptext">
                            Prema Centru za vozila Hrvatske, Prosječno godišnje prijeđeni put kategorije N1 u 2019. godini iznosi 19.523 km
                        </div>
                    </label>
                    <select class="form-control" id="godisnja_km" v-model="god_km" required>
                        <option value="10000">10.000</option>
                        <option value="15000">15.000</option>
                        <option value="20000" selected>20.000</option>
                        <option value="25000">25.000</option>
                        <option value="30000">30.000</option>
                    </select>
                </div>
                <div>
                    <label class="label" for="rezim_voznje">
                        Odaberite režim vožnje za izračun?
                    </label>
                    <select class="form-control" id="rezim_voznje" v-model="rezim_voznje" required>
                        <option value="grad-zima">Gradska vožnja - zima</option>
                        <option value="autoput-zima">Autoput - zima</option>
                        <option value="kombi-zima">Kombinirana vožnja - zima</option>
                        <option value="grad-ljeto">Gradska vožnja - ljeto</option>
                        <option value="autoput-ljeto">Autoput - ljeto</option>
                        <option value="kombi-ljeto">Kombinirana vožnja - ljeto</option>
                    </select>
                </div>
                <div>
                    <h4>Odaberite svoj novi električni Renault za usporedbu:</h4>
                    <div v-if="carsError" class="errorText">
                        <p>Molimo Vas da odaberete model automobila.</p>
                    </div>
                    <input class="checkbox-cars form-control" type="radio" name="cars" id="car-1" v-model="odabir_auta"
                           value="Clio"/>
                    <label class="for-checkbox-cars" for="car-1">
                        <img src="../assets/bijeli.png" alt="Gospodarsko lako vozilo Kangoo Express dCi 95 N1"/>
                        <span>KANGOO Z.E. N1 / KANGOO EXPRESS DCI 80 N1</span>
                    </label>
                    <input class="checkbox-cars" type="radio" name="cars" id="car-2" v-model="odabir_auta"
                           value="Twingo"/>
                    <label class="for-checkbox-cars" for="car-2">
                        <img src="../assets/crveni.png" alt="Gospodarsko lako vozilo Kangoo Express dCi 80 N1"/>
                        <span>KANGOO Z.E. N1 / KANGOO EXPRESS dCi 95 N1 </span>
                    </label>
                    <input class="checkbox-cars form-control" type="radio" name="cars" id="car-3" v-model="odabir_auta"
                           value="Captur"/>
                    <label class="for-checkbox-cars" for="car-3">
                        <img src="../assets/plavi.png" alt="Gospodarsko lako vozilo Kangoo Express dCi 115 N1"/>
                        <span>KANGOO Z.E. N1 / KANGOO EXPRESS dCi 115 N1</span>
                    </label>
                </div>
                <div class="padding">
                    <input type="submit" value="Krenimo na putovanje s Vašim novim električnim Renaultom!"/>
                </div>
            </fieldset>
        </form>

        <div class="rezultat" v-if="doneCalculate">
            <div class="padding"></div>
            <h2 class="naslov-za-izracun">Ušteda</h2>
            <p class="smallerText">
                Obzirom na iznimno visoku učinkovitost, korištenje električnog lakog gospodarskog vozila u usporedbi s
                konvencionalnim modelom rezultira smanjenju emisija CO<sub>2</sub> za čak {{ new Intl.NumberFormat("de-DE").format(atmosfera_kangooTech_kangooExpress) }}
                tona CO<sub>2</sub> godišnje.
                Što to konkretno znači? Da budemo svjesni koja je to ogromna količina koju možemo osobno uštedjeti i
                time doprinijeti borbi protiv klimatskih promjena, kažimo da povratni let ekonomske klase iz Londona za
                New York uzrokuje oko 1,800 tona CO<sub>2</sub>.
            </p>
            <div class="padding">
                <table class="tablica-rezultati">
                    <thead>
                    <tr>
                        <th colspan="2">Ukupna emisija (t CO<sub>2</sub>/god)</th>
                    </tr>
                    </thead>
                    <tbody>
                    <tr>
                        <td><strong>Kangoo Express</strong></td>
                        <td><strong>Kangoo Z.E.</strong></td>
                    </tr>
                    <tr>
                        <td>
                            {{ new Intl.NumberFormat("de-DE", { minimumFractionDigits: 3}).format(god_emisija_kangooExpress) }}
                        </td>
                        <td>
                            {{ new Intl.NumberFormat("de-DE").format(god_emisija_kangooTech) }}
                        </td>
                    </tr>
                    </tbody>
                </table>
            </div>
            <div class="padding"></div>
            <h2 class="naslov-za-izracun">
                Razlika između konvencionalnog i električnog automobila
            </h2>
            <div class="padding"></div>
            <div class="padding">
                <table class="tablica-rezultati">
                    <thead>
                    <tr>
                        <th colspan="2">
                            Broj stabala koji bi bio potreban za apsorpciju CO<sub>2</sub>
                            na godišnjoj razini (kom / god)
                        </th>
                    </tr>
                    </thead>
                    <tbody>
                    <tr>
                        <td><strong>Kangoo Express</strong></td>
                        <td><strong>Kangoo Z.E.</strong></td>
                    </tr>
                    <tr>
                        <td>
                            {{ new Intl.NumberFormat("de-DE").format(usteda_drvece_kangooExpress) }}
                        </td>
                        <td>
                            {{ new Intl.NumberFormat("de-DE").format(usteda_drvece_kangooTech) }}
                        </td>
                    </tr>
                    </tbody>
                </table>
            </div>
            <div class="padding">
                <table class="tablica-rezultati">
                    <thead>
                    <tr>
                        <th colspan="2">
                            Volumen morske vode koji bi bio potreban za apsorpciju CO<sub>2</sub>
                            na godišnjoj razini (m<sup>3</sup> / god)
                        </th>
                    </tr>
                    </thead>
                    <tbody>
                    <tr>
                        <td><strong>Kangoo Express</strong></td>
                        <td><strong>Kangoo Z.E.</strong></td>
                    </tr>
                    <tr>
                        <td>
                            {{ new Intl.NumberFormat("de-DE").format(usteda_voda_kangooExpress) }}
                        </td>
                        <td>
                            {{ new Intl.NumberFormat("de-DE").format(usteda_voda_kangooTech) }}
                        </td>
                    </tr>
                    </tbody>
                </table>
            </div>
            <div class="padding">
                <table class="tablica-rezultati">
                    <thead>
                    <tr>
                        <th colspan="2">Količina energije za vožnju na godišnjoj razini</th>
                    </tr>
                    </thead>
                    <tbody>
                    <tr>
                        <td><strong>Kangoo Express</strong></td>
                        <td><strong>Kangoo Z.E.</strong></td>
                    </tr>
                    <tr>
                        <td>
                            {{ new Intl.NumberFormat("de-DE").format(god_tro_pog_kangooExpress_help) }} (l/god)
                        </td>
                        <td>
                            {{ new Intl.NumberFormat("de-DE").format(god_tro_pog_kangooTech_help) }} (kWh/god)
                        </td>
                    </tr>
                    </tbody>
                </table>
            </div>
            <div class="rezultatiSlika">
                <div class="padding"></div>
                <h2 class="naslov-za-izracun">Što to konkretno znači za okoliš?</h2>
                <div class="padding"></div>
                <p>
                    Desetogodišnje stablo u prosjeku apsorbira 22 kg CO2 godišnje, što znači kada vozite električni
                    Renault svake godine kao da ste posadili
                    {{
                        new Intl.NumberFormat("de-DE").format(
                            Math.round(usteda_drvece_kangooTech_kangooExpress)
                        )
                    }} stabala.
                </p>
                <p>
                    Jeste li znali da i morska voda apsorbira CO2 i to 2,65g CO2 po litri? U našem slučaju to znači
                    {{
                        Math.round(usteda_voda_kangooTech_kangooExpress * 1000)
                    }}
                    ušteđenih litara morske vode.
                </p>

                <img src="../assets/Kangoo-rezultati.webp" class="rezultati-background Kangoo"/>
                <p class="drvece">
                    {{
                        new Intl.NumberFormat("de-DE").format(
                            Math.round(usteda_drvece_kangooTech_kangooExpress)
                        )
                    }}
                    <span>kom/god</span>
                </p>
                <p class="voda">
                    {{
                        Math.round(usteda_voda_kangooTech_kangooExpress * 1000)
                    }}
                    <span>l</span>
                </p>
            </div>
            <div class="padding">
                <table class="tablica-rezultati">
                    <thead>
                    <tr>
                        <th colspan="2">Ušteda prilikom odabira električnog auta</th>
                    </tr>
                    </thead>
                    <tbody>
                    <tr>
                        <td>
                            CO<sub>2</sub> ekvivalent uklanjanja vozila iz prometa na
                            godišnjoj razini <br class="newLine"/>
                            (kg CO<sub>2</sub> / god)
                        </td>
                        <td>
                            {{
                                new Intl.NumberFormat("de-DE").format(
                                    uklanjanje_vozila_kangooTech_kangooExpress
                                )
                            }}
                        </td>
                    </tr>
                    <tr>
                        <td>
                            CO<sub>2</sub> koji nije emitiran u atmosferu (tCO<sub>2</sub> /
                            god)
                        </td>
                        <td>
                            {{ new Intl.NumberFormat("de-DE").format(atmosfera_kangooTech_kangooExpress) }}
                        </td>
                    </tr>
                    </tbody>
                </table>
            </div>
            <div class="padding">
                <h3>
                    Što sve ovo znači za Vas?
                </h3>
                <p>
                    Nabavkom Renault baterijskog električnog lakog gospodarskog vozila ne samo da ćete se
                    voziti tiše i ugodnije, već ćete i
                    doprinijeti očuvanju okoliša. Vaše će poslovanje biti
                    klimatski neutralnije, što će Vam omogućiti
                    tržišnu prepoznatljivost kao kompanije i
                    pojedinaca koji djeluju u skladu s načelima održivog razvoja. Služit ćete kao primjer dobre
                    prakse poslovnim partnerima i krajnjim kupcima.
                </p>
            </div>
            <div class="bottomText">
                <h3>
                    Jeste li se već odlučili za kupnju novog električnog Renaulta?
                </h3>
                <p><a
                    href="https://www.fkangooTechu.hr/hr/energetska_ucinkovitost/poticanje_energetske_ucinkovitosti_u_prometu/sufinanciranje_nabave_energetski_ucinkovitijih_vozila/"
                    target="_blank">
                    Jeste li znali da pritom možete dobiti izdašnu subvenciju Fonda za zaštitu okoliša i energetsku
                    učinkovitost?</a></p>
                Kako biste se informirali i osobno doživjeli sve prednosti električnih vozila dobrodošli ste u naš
                prodajni centar na adresi Mihačeva draga 7 u Rijeci.
                Javite nam se za dogovor na <a href="tel:+38551226620">+385 51 226 620</a>, tu smo za Vas.
            </div>
        </div>
    </div>
</template>

<script>
import Vue from "vue";

export default {
    data() {
        return {
            auti: [
                {
                    id: 1,
                    name: "Kangoo Z.E.",
                    prosj_pot_en: 15.2,
                    prosj_CO2_emisija: 0.3,
                    kapacitet_bat: 36,
                    cijena_novog_voz: 200545,
                    subvencija: 70000,
                    ukupno_cijena: 130545,
                    teh_i_reg: 1350,
                    osiguranje: 1400,
                    god_odrz: 550,
                },
                {
                    id: 2,
                    name: "Kangoo Express",
                    prosj_pot_en: 5.6,
                    prosj_CO2_emisija: 148,
                    cijena_novog_voz: 125122,
                    ukupno_cijena: 125122,
                    teh_i_reg: 1650,
                    osiguranje: 1400,
                    god_odrz: 1300,
                },
            ],

            vrsta_punionice: "",

            omjer: "",
            rezim_voznje: "",
            cijena_el_energije: 0.8,
            cijena_euro_95: 10.8,
            cijena_euro_100: 11.14,
            cijena_dg_euro: 10.28,
            god_km: 20000,
            emisijski_faktor: null,
            emisijski_faktor2: 0.137,
            rez_em_fak: null,
            odabir_auta: null,

            doneCalculate: false,

            god_emisija_kangooTech: null,
            god_emisija_kangooExpress: null,


            god_usteda_kangooTech_kangooExpress: null,

            usteda_drvece_kangooTech: null,
            usteda_drvece_kangooExpress: null,

            usteda_drvece_kangooTech_kangooExpress: null,

            usteda_voda_kangooTech: null,
            usteda_voda_kangooExpress: null,

            usteda_voda_kangooTech_kangooExpress: null,

            uklanjanje_vozila_kangooTech_kangooExpress: null,

            atmosfera_kangooTech_kangooExpress: null,

            postotak_usteda: null,

            god_tro_pog_kangooExpress_help: null,
            god_tro_pog_kangooTech_help: null,

            god_tro_pog_kangooExpress: null,
            god_tro_pog_kangooTech: null,

            ukupni_troskovi_kangooTech: [],
            ukupni_troskovi_kangooExpress: [],

            cijena_voz_po_god: [],
            fiksni_trosak_el: [],
            ukupni_trosak_el: [],

            ukupni_prihod_el: [],
            ukupni_prihod_kon: [],
            ukupni_prihod_ke: [],

            carsError: false,

        };
    },
    methods: {
        checkValidation(){
            if(this.odabir_auta !== null){
                this.carsError = false;
                this.calculate();
            }else{
                this.carsError = true;
            }
        },
        calculate() {
            this.god_tro_pog_kangooExpress_help = (this.god_km / 100) * this.auti[1].prosj_pot_en;
            this.god_tro_pog_kangooTech_help = ((this.god_km / 100) * this.auti[0].prosj_pot_en) / 10;

            /*this.god_tro_pog_kangooExpress = this.god_tro_pog_kangooExpress_help * this.cijena_euro_95;
            this.god_tro_pog_kangooTech = this.god_tro_pog_kangooTech_help * this.cijena_el_energije;*/

            let br_za_vrstu_punionice = null;
            if(this.vrsta_punionice === "javne"){
                br_za_vrstu_punionice = 1;
            }else{
                if(this.omjer !== null){
                    br_za_vrstu_punionice = this.omjer;
                }else{
                    br_za_vrstu_punionice = 0;
                }
            }

            if(br_za_vrstu_punionice !== 0){
                this.rez_em_fak = br_za_vrstu_punionice * this.emisijski_faktor2 + (1-br_za_vrstu_punionice)*(1-this.emisijski_faktor)*this.emisijski_faktor2;
            }else{
                this.rez_em_fak = (1-br_za_vrstu_punionice)*(1-this.emisijski_faktor)*this.emisijski_faktor2;
            }

            console.log(this.rez_em_fak)



            this.god_emisija_kangooTech =
                this.god_tro_pog_kangooTech_help *
                Math.pow(10, -2) *
                this.rez_em_fak;
            this.god_emisija_kangooExpress =
                (this.god_km / 100) *
                (this.auti[1].prosj_CO2_emisija * 100) *
                Math.pow(10, -6);


            this.god_usteda_kangooTech_kangooExpress =
                ((this.god_emisija_kangooExpress - this.god_emisija_kangooTech) * 100) /
                this.god_emisija_kangooExpress;

            this.usteda_drvece_kangooTech = (1000 * this.god_emisija_kangooTech) / 22;
            this.usteda_drvece_kangooExpress = (1000 * this.god_emisija_kangooExpress) / 22;

            this.usteda_drvece_kangooTech_kangooExpress =
                this.usteda_drvece_kangooExpress - this.usteda_drvece_kangooTech;

            this.usteda_voda_kangooTech =
                (this.god_emisija_kangooTech * Math.pow(10, 3)) / 2.65 / 1000;
            this.usteda_voda_kangooExpress =
                (this.god_emisija_kangooExpress * Math.pow(10, 3)) / 2.65 / 1000;

            this.usteda_voda_kangooTech_kangooExpress = this.usteda_voda_kangooExpress - this.usteda_voda_kangooTech;

            this.uklanjanje_vozila_kangooTech_kangooExpress =
                ((this.god_emisija_kangooExpress - this.god_emisija_kangooTech) * Math.pow(10, 3)) /
                (123.4 * this.god_km);


            this.atmosfera_kangooTech_kangooExpress = this.god_emisija_kangooExpress - this.god_emisija_kangooTech;


            this.calculateUkupniTroskovi();

            this.doneCalculate = !this.doneCalculate;
            Vue.nextTick(() => {
                this.scrollToElement();
            });
        },

        calculateUkupniTroskovi() {
            for (let i = 0; i < 15; i++) {
                if (i === 0) {
                    this.ukupni_troskovi_kangooTech[i] = this.auti[0].ukupno_cijena + this.auti[0].teh_i_reg +
                        this.auti[0].osiguranje + this.auti[0].god_odrz + this.god_tro_pog_kangooTech;
                    this.ukupni_troskovi_kangooExpress[i] = this.auti[1].ukupno_cijena + this.auti[1].teh_i_reg +
                        this.auti[1].osiguranje + this.auti[1].god_odrz + this.god_tro_pog_kangooExpress;

                } else {
                    this.ukupni_troskovi_kangooTech[i] = this.ukupni_troskovi_kangooTech[i - 1] + this.auti[0].teh_i_reg +
                        this.auti[0].osiguranje + this.auti[0].god_odrz + this.god_tro_pog_kangooTech;
                    this.ukupni_troskovi_kangooExpress[i] = this.ukupni_troskovi_kangooExpress[i - 1] + this.auti[1].teh_i_reg +
                        this.auti[1].osiguranje + this.auti[1].god_odrz + this.god_tro_pog_kangooExpress;
                }
            }
        },

        scrollToElement() {
            const el = this.$el.getElementsByClassName("rezultat")[0];

            if (el) {
                el.scrollIntoView();
            }
        },
    },
    /*watch: {
        odabir_auta() {
            if (this.doneCalculate === true) {
                this.doneCalculate = !this.doneCalculate;
            }
        }
    }*/
};
</script>

<style scoped>
@import "../css/main.css";
</style>
